// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d603564","239":"8613d9b2","422":"2e5a766e","667":"ef24c60a"}[chunkId] + ".chunk.js";
};